<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="No filter"
    @change="handleInput"
  >
    <option
      v-for="option in options"
      :value="option.id"
      :key="option.id"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterCampaigns",
  props: {
    label: {
      type: String,
      default: "Campaign"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].campaigns;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "campaigns",
          value
        ]);
      }
    },
    options() {
      return [
        {id: null, label: "No filter"},
        ...this.$store.getters.activeCampaigns,
        {id: -1, label: "No Campaigns"},
        {id: -2, label: "All Campaigns"}
      ];
    },
    text() {
      if (this.filterValue) {
        if (this.filterValue === -1) {
          return "No Campaigns";
        } else if (this.filterValue === -2) {
          return "All Campaigns";
        } else {
          let campaign = this.$store.getters.activeCampaigns.find(campaign => campaign.id === this.filterValue);
          return "Only " + campaign.label;
        }
      } else {
        return null;
      }
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
